import { NUDGES_WIDGET_NAMES } from "@/constants/widget-names";
import AnalyticsEventsCollectorInterface from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsCollectorInterface";
import { AnalyticsEventsFactory } from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsFactory";
import MutationObserverInjector from "@ui-utils/Injector/MutationObserverInjector";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import NudgesWidget from "./NudgesWidget";

class NudgesWidgetInjector {
    constructor(
        private readonly placeholderSelector: string,
        private readonly logger: LoggerInterface,
        private readonly eventsCollector: AnalyticsEventsCollectorInterface,
        private readonly analyticsEventsFactory: AnalyticsEventsFactory,
        private readonly moi: MutationObserverInjector
    ) {}

    start(): void {
        this.logger.debug("NudgesWidgetInjector start", {
            placeholderSelector: this.placeholderSelector,
        });

        const targets$ = this.moi.register({
            targetSelector: this.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.logger?.debug("NudgesWidgetInjector found placeholder", {
                placeholder,
            });

            const widget = new NudgesWidget(
                {
                    target: placeholder,
                },
                this.logger
            );

            void widget.init().then(() => {
                this.eventsCollector.pushEvent(
                    this.analyticsEventsFactory.createWidgetInjected(
                        NUDGES_WIDGET_NAMES.NUDGES_WIDGET
                    )
                );
            });
        });
    }
}

export default NudgesWidgetInjector;
